import { getStorageByType } from '@/_utils/get-storage-by-type';
import { EStorageType } from '@/_utils/_types';

type TSetCacheParams<TData> = {
  key: string;
  data: TData;
  storageType?: EStorageType;
};

export const setCache = <TData>({
  key,
  data,
  storageType,
}: TSetCacheParams<TData>): void => {
  const storage = getStorageByType({ storageType });

  if (!storage) {
    return;
  }

  return storage.setItem(key, JSON.stringify(data));
};
